<template>
  <div v-if="isShow && match.is_show">
    <!-- <span class="text-sm" v-if="!match.start_time">{{ betCloseTime() }}</span> -->
    <!-- betting team card -->
    <div
      v-if="type !== 'history'"
      class="match-container mb-2 px-1 py-2"
      :class="[
        match.is_big ? 'big-match-design' : '',
        type === 'body' ? 'type-body' : '',
        type === 'maung' ? 'type-maung' : '',
      ]"
    >
      <span
        class="text-md mt-1 pl-2 league-meta"
        v-if="match.start_time"
        ><span
          class="text-lg"
          v-if="match.is_big && $route.path !== '/maung-fb'"
        ></span
        ><span class="font-weight-bolder text-md" v-if="match.league"
          >{{ match.league }}
        </span>
        <!-- <span class="text-danger" v-if="match.is_big && $route.path !== '/maung-fb'">
                            ( {{$t('football.big_match')}} )  <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/luungal/icons/star.png" style="width: 1rem; height: 1rem;" alt=""> </span> -->
        ( {{ betTime(match.start_time) }} )
      </span>
      <span class="text-danger" v-if="match.is_big">
        <img
          src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/luungal/icons/star.png"
          style="width: 1rem; height: 1rem"
          alt=""
        />
      </span>
      <br />
      <div
        class="upper-card w-100 d-flex justify-content-around"
        style="height: 40px"
      >
        <div
          class="upper-left-card d-flex"
          style="width: 50%"
          :class="[
            betMatch.selected_team === match.first_team &&
            !isGoalPor &&
            !isSoneMa
              ? 'active ' + ($route.path === '/maung-fb' ? 'bg-green' : '')
              : null,
            betMatch.selected_team === match.first_team &&
            !isGoalPor &&
            !isSoneMa &&
            type == 'body'
              ? 'body-active'
              : '',
            betMatch.selected_team === match.first_team &&
            !isGoalPor &&
            !isSoneMa &&
            type == 'maung'
              ? 'maung-active'
              : '',
          ]"
          @click="
            $playSound();
            type === 'history'
              ? ''
              : checkTeam(match.first_team, null, match.first_team_id);
          "
        >
          <span
            class="my-auto mx-auto pt-1"
            style="font-size: 1.1rem !important"
          >
            <b> {{ match.first_team }}</b>
          </span>
          <div
            class="mx-auto my-auto kyay-badge"
            v-if="match.kyayed_team === match.first_team && !isKyayHistory"
          >
            {{
              getFBOrder.type === "maung"
                ? match.maung_kyay === "~"
                  ? "=="
                  : match.maung_kyay
                : match.body_kyay === "~"
                ? "=="
                : match.body_kyay
            }}
          </div>
        </div>

        <div
          class="upper-right-card d-flex"
          style="width: 50%"
          :class="[
            betMatch.selected_team === match.second_team &&
            !isGoalPor &&
            !isSoneMa
              ? 'active ' + ($route.path === '/maung-fb' ? 'bg-green' : '')
              : null,
            betMatch.selected_team === match.second_team &&
            !isGoalPor &&
            !isSoneMa &&
            type == 'body'
              ? 'body-active'
              : '',
            betMatch.selected_team === match.second_team &&
            !isGoalPor &&
            !isSoneMa &&
            type == 'maung'
              ? 'maung-active'
              : '',
          ]"
          @click="
            $playSound();
            type === 'history'
              ? ''
              : checkTeam(match.second_team, null, match.second_team_id);
          "
        >
          <div
            class="mx-auto my-auto kyay-badge"
            v-if="match.kyayed_team === match.second_team && !isKyayHistory"
          >
            {{
              getFBOrder.type === "maung"
                ? match.maung_kyay === "~"
                  ? "=="
                  : match.maung_kyay
                : match.body_kyay === "~"
                ? "=="
                : match.body_kyay
            }}
          </div>
          <span
            class="text-center my-auto mx-auto pt-1"
            style="font-size: 1.1rem !important"
          >
            <b>{{ match.second_team }}</b>
          </span>
        </div>
      </div>
      <div class="lower-card w-100 d-flex p-1 justify-content-center">
        <div class="d-flex kyay-left">
          <div
            class="mx-auto my-auto goal-por pt-2"
            style="font-size: 15px"
            :class="[
              betMatch.selected_team === match.first_team && isGoalPor
                ? 'active ' + ($route.path === '/maung-fb' ? 'bg-green' : '')
                : null,
              betMatch.selected_team === match.first_team &&
              isGoalPor &&
              type == 'body'
                ? 'body-active'
                : '',
              betMatch.selected_team === match.first_team &&
              isGoalPor &&
              type == 'maung'
                ? 'maung-active'
                : '',
            ]"
            v-if="!isKyayHistory"
            @click="
              $playSound();
              type === 'history'
                ? ''
                : checkTeam(match.first_team, 'up', match.first_team_id);
            "
          >
            <b>
              {{ $t("football.goal_up") }}
            </b>
          </div>
        </div>

        <div
          class="goal-kyay-chip text-center pt-1"
          @click="
            $playSound();
            type === 'history' ? '' : changeGoalPor();
          "
          v-if="isKyayHistory"
        >
          {{
            getFBOrder.type === "maung"
              ? history.maung_goal_kyay
              : history.body_goal_kyay
          }}
        </div>
        <div
          class="goal-kyay-chip text-center pt-1"
          @click="
            $playSound();
            type === 'history' ? '' : changeGoalPor();
          "
          v-else
        >
          <b>
            {{
              getFBOrder.type === "maung"
                ? match.maung_goal_kyay
                : match.body_goal_kyay
            }}
          </b>
        </div>
        <div class="d-flex kyay-right">
          <div
            class="mx-auto my-auto goal-por pt-2"
            style="font-size: 15px"
            :class="[
              betMatch.selected_team === match.second_team && isGoalPor
                ? 'active ' + ($route.path === '/maung-fb' ? 'bg-green' : '')
                : null,
              betMatch.selected_team === match.second_team &&
              isGoalPor &&
              type == 'body'
                ? 'body-active'
                : '',
              betMatch.selected_team === match.second_team &&
              isGoalPor &&
              type == 'maung'
                ? 'maung-active'
                : '',
            ]"
            v-if="!isKyayHistory"
            @click="
              $playSound();
              type === 'history'
                ? ''
                : checkTeam(match.second_team, 'down', match.second_team_id);
            "
          >
            <b>
              {{ $t("football.goal_down") }}
            </b>
          </div>
        </div>
      </div>

      <!-- SONE MA  -->
      <div
        class="upper-card w-100 d-flex justify-content-around"
        style="height: 40px"
      >
        <div
          class="upper-left-card d-flex"
          style="width: 50%"
          :class="[
            betMatch.selected_team === match.first_team && isSoneMa
              ? 'active ' + ($route.path === '/maung-fb' ? 'bg-green' : '')
              : null,
            betMatch.selected_team === match.first_team &&
            isSoneMa &&
            type == 'body'
              ? 'body-active'
              : '',
            betMatch.selected_team === match.first_team &&
            isSoneMa &&
            type == 'maung'
              ? 'maung-active'
              : '',
          ]"
          @click="
            $playSound();
            type === 'history'
              ? ''
              : checkTeam(match.first_team, null, match.first_team_id, 'sone');
          "
        >
          <span class="my-auto mx-auto">
            <b> {{ $t("football.even") }}</b>
          </span>
        </div>

        <div
          class="upper-right-card d-flex"
          style="width: 50%"
          :class="[
            betMatch.selected_team === match.second_team && isSoneMa
              ? 'active ' + ($route.path === '/maung-fb' ? 'bg-green' : '')
              : null,
            betMatch.selected_team === match.second_team &&
            isSoneMa &&
            type == 'body'
              ? 'body-active'
              : '',
            betMatch.selected_team === match.second_team &&
            isSoneMa &&
            type == 'maung'
              ? 'maung-active'
              : '',
          ]"
          @click="
            $playSound();
            type === 'history'
              ? ''
              : checkTeam(match.second_team, null, match.second_team_id, 'ma');
          "
        >
          <span class="text-center my-auto mx-auto">
            <b>
              {{ $t("football.odd") }}
            </b>
          </span>
        </div>
      </div>
      <!-- END SONE MA  -->
    </div>

    <!-- history team card -->
    <div v-if="type === 'history'" class="match-container mb-2">
      <div
        class="upper-card w-100 d-flex justify-content-around"
        style="height: 40px"
      >
        <!-- style="width: calc(50% - 100px)" -->
        <div
          class="upper-left-card d-flex"
          style="width: calc(50% - 40px)"
          :class="
            betMatch.selected_team === match.first_team
              ? 'active ' + ($route.path === '/maung-fb' ? 'bg-green' : '')
              : null
          "
          @click="
            $playSound();
            type === 'history'
              ? ''
              : checkTeam(match.first_team, 'up', match.first_team_id);
          "
        >
          <span class="my-auto mx-auto" style="">
            <!-- <b
                            >{{ firstMatchNo() }}.{{ match.first_team }}</b
                        > -->
            <b>{{
              $store.state.language === "mm"
                ? match.first_team
                : match.first_team_en
            }}</b>
          </span>
        </div>
        <div class="d-flex" v-if="isGoalPor">
          <i
            style="font-size: 20px; color: red; margin-right: 2px"
            class="fas fa-long-arrow-alt-up my-auto"
          ></i>
        </div>
        <div
          class="upper-middle-card d-flex justify-content-center"
          style="width: 80px"
        >
          <!-- <div>
                        <img
                            src="https://via.placeholder.com/35"
                            class="team-image"
                            alt=""
                        />
                    </div> -->
          <div
            class="text-center px-1"
            :class="type === 'history' ? 'd-flex' : ''"
            style="width: 80px"
          >
            <!-- 0:0 -->
            <div v-if="type !== 'history'"><b>Close</b></div>
            <div v-if="type !== 'history'">
              <!-- {{ match.close_time.hh }} :
                            {{ match.close_time.mm }} {{ match.close_time.A }} -->
            </div>
            <div v-if="type === 'history'" class="text-danger mx-auto my-auto">
              <h2>
                {{ match.first_team_result + " : " + match.second_team_result }}
              </h2>
            </div>
          </div>
          <!-- <div>
                        <img
                            src="https://via.placeholder.com/35"
                            class="team-image"
                            alt=""
                        />
                    </div> -->
        </div>
        <div class="d-flex" v-if="isGoalPor">
          <i
            style="font-size: 20px; color: red; color: red; margin-left: 2px"
            class="fas fa-long-arrow-alt-down my-auto"
          ></i>
        </div>
        <div
          class="upper-right-card d-flex"
          style="width: calc(50% - 40px)"
          :class="
            betMatch.selected_team === match.second_team
              ? 'active ' + ($route.path === '/maung-fb' ? 'bg-green' : '')
              : null
          "
          @click="
            $playSound();
            type === 'history'
              ? ''
              : checkTeam(match.second_team, 'down', match.second_team_id);
          "
        >
          <span class="text-center my-auto mx-auto">
            <!-- <b
                            >{{ secondMatchNo() }}.{{ match.second_team }}</b
                        > -->
            <b>{{
              $store.state.language === "en"
                ? match.second_team_en
                : match.second_team
            }}</b>
          </span>
        </div>
      </div>
      <div
        class="lower-card w-100 d-flex p-1 justify-content-center"
        style="height: 40px"
      >
        <div class="d-flex kyay-left pt-1">
          <div
            class="mx-auto kyay-text"
            v-if="match.kyayed_team === match.first_team && !isKyayHistory"
          >
            {{
              getFBOrder.type === "maung"
                ? match.maung_kyay === "~"
                  ? "=="
                  : match.maung_kyay
                : match.body_kyay === "~"
                ? "=="
                : match.body_kyay
            }}
          </div>
          <div
            class="mx-auto kyay-text"
            v-if="match.kyayed_team === match.first_team && isKyayHistory"
          >
            {{
              getFBOrder.type === "maung"
                ? history.maung_kyay === "~"
                  ? "=="
                  : history.maung_kyay
                : history.body_kyay === "~"
                ? "=="
                : history.body_kyay
            }}
          </div>
        </div>
        <div
          class="goal-kyay-chip text-center pt-1"
          @click="
            $playSound();
            type === 'history' ? '' : changeGoalPor();
          "
          v-if="isKyayHistory"
        >
          Gp{{
            getFBOrder.type === "maung"
              ? history.maung_goal_kyay
              : history.body_goal_kyay
          }}
        </div>
        <div
          class="goal-kyay-chip text-center pt-1"
          @click="
            $playSound();
            type === 'history' ? '' : changeGoalPor();
          "
          v-else
        >
          Gp{{
            getFBOrder.type === "maung"
              ? match.maung_goal_kyay
              : match.body_goal_kyay
          }}
        </div>
        <div class="d-flex kyay-right" style="width: calc(50%-25px)">
          <div
            class="mx-auto kyay-text"
            v-if="match.kyayed_team === match.second_team && !isKyayHistory"
          >
            {{
              getFBOrder.type === "maung"
                ? match.maung_kyay === "~"
                  ? "=="
                  : match.maung_kyay
                : match.body_kyay === "~"
                ? "=="
                : match.body_kyay
            }}
          </div>
          <div
            class="mx-auto kyay-text"
            v-if="match.kyayed_team === match.second_team && isKyayHistory"
          >
            {{
              getFBOrder.type === "maung"
                ? history.maung_kyay === "~"
                  ? "=="
                  : history.maung_kyay
                : history.body_kyay === "~"
                ? "=="
                : history.body_kyay
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
// Import the Luxon library
import { DateTime } from "luxon";

export default {
  //   props: ['match', 'type'],
  props: {
    match: Object,
    history: Object,
    type: String,
    onMyEvent: Function,
    isKyayHistory: {
      type: Boolean,
      default: false,
    },
    type: String,
  },

  data() {
    return {
      targetTimeZone: "Asia/Yangon",
      currentTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      isGoalPor: false,
      isSoneMa: false,
      interval: null,
      isShow: true,
      isLast: false,
      betMatch: {},
      isSelect: false,
    };
  },
  computed: {
    ...mapGetters(["getFBOrder"]),
  },
  methods: {
    betTime(time) {
      return moment(new Date(time)).format("LT");
    },
    firstMatchNo() {
      return this.match.match_no * 2 - 1;
    },
    secondMatchNo() {
      return this.match.match_no * 2;
    },
    ...mapMutations([
      "setFBMatches",
      "updateFBMatches",
      "removeFBMatch",
      "setWholeFBMatches",
    ]),
    checkTeam(
      selectedTeam,
      goalUpDown = null,
      selectedTeamId = null,
      soneMa = null
    ) {
      const matchIndex = this.getFBOrder.fb_matches.findIndex(
        (match) => match.id === this.match.id
      );

      if (selectedTeam === this.betMatch.selected_team) {
        this.betMatch = {};
        this.removeFBMatch(matchIndex);
        return false;
      }
      this.betMatch = {};
      this.betMatch = this.match;
      this.betMatch.selected_team = selectedTeam;
      this.betMatch.selected_team_id = selectedTeamId;
      if (goalUpDown && !soneMa) {
        this.betMatch.goal_up_down = goalUpDown;
        this.isGoalPor = true;
        this.isSoneMa = null;
        this.betMatch.sone_ma = null;
      } else if (!goalUpDown && soneMa) {
        this.betMatch.sone_ma = soneMa;
        this.isSoneMa = true;
        this.isGoalPor = null;
        this.betMatch.goal_up_down = null;
      } else {
        this.isGoalPor = null;
        this.betMatch.goal_up_down = null;
        this.isSoneMa = null;
        this.betMatch.sone_ma = null;
      }

      if (matchIndex === -1) this.setFBMatches(this.betMatch);
      else {
        this.updateFBMatches({
          index: matchIndex,
          value: this.betMatch,
        });
      }
      return true;
    },
    changeGoalPor() {
      this.isGoalPor = !this.isGoalPor;
      this.checkFBMatchTime();
    },
    checkFBMatchTime() {
      const matchTime = new Date(this.match.start_time);
      const nowTime = new Date();
      this.isShow = matchTime > nowTime;
      if (!this.isShow) {
        const index = this.getFBOrder.fb_matches.findIndex(
          (match) => match.id === this.match.id
        );
        if (index !== -1) {
          let newDatas = JSON.parse(JSON.stringify(this.getFBOrder.fb_matches));
          newDatas.splice(index, 1);
          this.setWholeFBMatches(newDatas);
        }
      }
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
  unmounted() {
    clearInterval(this.interval);
  },
  mounted() {
    // this.currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.onMyEvent(() => {
      this.betMatch = {};
    });
    if (this.type !== "history") {
      this.checkFBMatchTime();
      this.interval = setInterval(() => this.checkFBMatchTime(), 3000);
    }
  },
};
</script>
<style scoped>
.league-meta {
  color: #b8b3a8;
  font-weight: 600;
}
.kyay-text {
  font-size: 15px;
  font-weight: 700;
}
.kyay-badge {
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 1px;
  border-radius: 6px;
  padding: 2px 8px;
}
.goal-kyay-chip {
  min-width: 58px;
  width: 70px;
  height: 32px;
  border-radius: 8px;
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: 1px;
}
.type-body .kyay-text {
  color: #ff7a7a;
}
.type-maung .kyay-text {
  color: #3dd68c;
}
.type-body .kyay-badge,
.type-body .goal-kyay-chip {
  background: linear-gradient(180deg, #ff7a7a, #e53935);
  color: #fff;
}
.type-maung .kyay-badge,
.type-maung .goal-kyay-chip {
  background: linear-gradient(180deg, #5ee09a, #1faa59);
  color: #0b1a10 !important;
}
.big-match-design {
  border-color: rgba(255, 210, 77, 0.28) !important;
}
.goal-por {
  text-align: center;
  color: #fff !important;
  border: 0;
  border-radius: 8px;
  margin-right: 100px;
  padding-bottom: 5px;
  width: 100%;
  height: 34px !important;
  font-size: 12px !important;
}
.type-body .goal-por,
.type-body .upper-left-card,
.type-body .upper-right-card,
.type-maung .goal-por,
.type-maung .upper-left-card,
.type-maung .upper-right-card {
  background: #2a2a2a;
}
.goal-por.body-active,
.upper-right-card.body-active,
.upper-left-card.body-active {
  background: linear-gradient(180deg, #ff7a7a, #e53935) !important;
  color: #fff !important;
}
.goal-por.maung-active,
.upper-right-card.maung-active,
.upper-left-card.maung-active,
.bg-green {
  background: linear-gradient(180deg, #5ee09a, #1faa59) !important;
  color: #0b1a10 !important;
}
.kyay-left,
.kyay-right {
  width: calc(50% - 30px);
  margin: 0px;
}
.kyay-left {
  margin-right: 5px;
}
.kyay-right {
  margin-left: 5px;
}
.team-image {
  width: 35px;
  height: 35px;
  border-radius: 3px;
  margin: 3px;
}
.match-container {
  background: #1c1c1c;
  border: 0;
  border-radius: 12px;
  color: #fff;
  padding: 8px 6px 6px;
}
hr {
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
}

.upper-right-card,
.upper-left-card {
  color: #fff;
  border: 0;
  border-radius: 8px;
  margin-top: 3px;
  margin-bottom: 3px;
  cursor: pointer;
}
.goal-por,
.goal-kyay-chip {
  cursor: pointer;
}

.upper-right-card {
  margin-left: 3px;
  margin-right: 3px;
}
.upper-left-card {
  margin-left: 3px;
  margin-right: 3px;
}

.upper-right-card.active,
.upper-left-card.active {
  border-radius: 8px;
}
</style>
